import { fg } from '@atlassian/jira-feature-gating';
import {
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';

import { createSemanticModelResource } from './createSemanticModelResource.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const itamDashboardsSemanticModelResource: RouteResource<any> = createSemanticModelResource({
	hostingProduct: 'jsm-cmdb',
	location: () => (fg('jsm_reporting_enable_itam_category_locations') ? 'itam_default' : 'itam'),
	products: ['jsm-cmdb'],
	subProducts: ['jsm'],
	desiredOrder: ['jsm-cmdb', 'jira', 'goals', 'devops', 'xray'],
});

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const useItamDashboardsSemanticModel = (): UseResourceHookResponse<any> =>
	useResource(itamDashboardsSemanticModelResource);
